import { Chip } from "@mui/material";
import { ReactNode, useState } from "react";
import { Grid, Link } from "../mui";

export const DataArray = (props: { value?: (ReactNode | undefined)[] | undefined; max?: number }) => {
  const [max, setMax] = useState<number | undefined>(props.max);
  const displayItems = max && props.value ? props.value.slice(0, max) : props.value;
  const additionalCount = max && props.value && props.value.length > max ? props.value.length - max : 0;

  return (
    <Grid container spacing="xs">
      {displayItems?.map((x, index) => (
        <Grid item key={index}>
          <Chip label={x} />
        </Grid>
      ))}

      {additionalCount > 0 && (
        <Grid item display="flex" alignItems={"center"}>
          <Link
            underline="hover"
            onClick={(e) => {
              e.stopPropagation();
              setMax(undefined);
            }}
          >
            ..show {additionalCount} more
          </Link>
          {/* <Typography variant="inherit" onClick={() => {}}>
            ... and {additionalCount} more
          </Typography> */}
        </Grid>
      )}
    </Grid>
  );
};
